"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _DragDropRow = _interopRequireDefault(require("../../rows/DragDropRow"));

var _HelpHint = _interopRequireDefault(require("../../tooltips/HelpHint"));

var _LinkDropDownList = _interopRequireDefault(require("../../forms/LinkDropDownList"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source))).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class MultiDrag#DragDropColumn
 * @private
 * @ignore
 *
 * @desc This component is internal to the MultiDrag component and is used to render a column of drag/drop rows.
 *
 * @param {string} [data-id="drag-drop-column"]
 *    To define the base "data-id" value for the top-level HTML container.
 *
 * @param {object[]} rows
 *    The row objects. The shape of these objects must correspond to the expected props of your contentType.
 * @param {string} name
 *    The name of the column.
 * @param {number} index
 *    The index of the column. Used when executing callbacks.
 * @param {object} contentType
 *    A react component to be used as a template for rendering rows. Can also be a function that returns JSX;
 *    function is passed all of the props of the column, including its handlers.
 * @param {string} [labelEmpty]
 *    The placeholder string for when a column is empty.
 * @param {string} [className]
 *    CSS classes to set on the top-level HTML container.
 * @param {number} [ghostRowAt]
 *    Display a ghost row to preview where a row would be inserted
 * @param {boolean} [disableSort=false]
 *    Determines whether the column is internally sortable
 * @param {number} [dragToEdge=false]
 *    If true, the drag index will only increment when the drag location has passed the edge of the row instead
 *    of being incremented after the halfway mark which is the default behavior.
 * @param {number} [helpText]
 *    When provided, this text appears withing a helphint next to the column title/name
 *
 * @param {MultiDrag~onAdd} [onAdd]
 *    Callback to be passed to contentType (as onAdd).
 * @param {MultiDrag~onRemove} [onRemove]
 *    Callback to be passed to contentType (as onRemove).
 * @param {MultiDrag~onDragDrop} onDrag
 *    Callback to be triggered when a row is dragged.
 * @param {MultiDrag~onDragDrop} onDrop
 *    Callback to be triggered when a row id dropped.
 * @param {MultiDrag~onCancel} onCancel
 *    Callback to be triggered when a drag event ends.
 * @param {MultiDrag~onScrolledToPosition} [onScrolledToTop]
 *    Callback to be triggered when the list is scrolled to the top.
 * @param {MultiDrag~onScrolledToPosition} [onScrolledToBottom]
 *    Callback to be triggered when the list is scrolled to the bottom. Can be used to fetch more data.
 *
 * @param {MultiDrag~onDragStart} [onDragStart]
 *    Callback to be triggered when a drag event starts.
 * @param {MultiDrag~onDragEnd} [onDragEnd]
 *    Callback to be triggered when a drag even ends.
 *
 */
module.exports = (_temp = _class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(_class, _React$Component);

  var _super = _createSuper(_class);

  function _class() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, _class);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_lastScroll", 0);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleScroll", function () {
      var container = _reactDom.default.findDOMNode(_this.refs.items);

      var rect = container.getBoundingClientRect();

      if (container.scrollTop === 0 && _this._lastScroll >= 0) {
        _this.props.onScrolledToTop(_this.props.index);
      } else if (container.scrollTop + rect.height >= container.scrollHeight && container.scrollTop >= _this._lastScroll) {
        _this.props.onScrolledToBottom(_this.props.index);
      }

      _this._lastScroll = container.scrollTop;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_renderRow", function (row, index, opts) {
      var inner = opts && opts.content;
      var _this$props = _this.props,
          contentType = _this$props.contentType,
          propsIndex = _this$props.index,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["contentType", "index"]);

      if (!inner) {
        inner = _underscore.default.isFunction(contentType) ? contentType(_objectSpread(_objectSpread({}, props), {}, {
          column: propsIndex,
          "data-id": "row_".concat(row.id),
          index: index
        }, row)) : /*#__PURE__*/_react.default.cloneElement(contentType, _objectSpread({
          column: propsIndex,
          "data-id": "row_".concat(row.id),
          index: index,
          onAdd: _this.props.onAdd,
          onRemove: _this.props.onRemove
        }, row));
      }

      return /*#__PURE__*/_react.default.createElement(_DragDropRow.default, {
        "data-id": "drag-drop-row_".concat(row.id),
        id: row.id,
        key: row.id,
        index: index,
        className: row.preview ? "selector-row--drop-preview" : "",
        disabled: opts && opts.disabled || row.disabled,
        column: propsIndex,
        onDrag: _this._handleDrag,
        onDrop: _this.props.onDrop,
        onDragStart: _this.props.onDragStart,
        onDragEnd: _this.props.onDragEnd,
        onCancel: _this.props.onCancel
      }, inner);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_renderRows", function () {
      var _context2;

      var rows = _this.props.rows;

      if (!rows || rows.length === 0) {
        var className = (0, _classnames.default)("no-items", {
          preview: typeof _this.props.ghostRowAt === "number"
        });
        return _this._renderRow({
          id: 0
        }, 0, {
          content: /*#__PURE__*/_react.default.createElement("div", {
            "data-id": "empty-placeholder",
            className: className
          }, _this.props.labelEmpty),
          disabled: true
        });
      }

      var renderedRows = (0, _map.default)(rows).call(rows, _this._renderRow);
      var ghostIndex = Math.min(rows.length, _this.props.ghostRowAt);
      return typeof _this.props.ghostRowAt === "number" ? (0, _concat.default)(_context2 = []).call(_context2, (0, _slice.default)(renderedRows).call(renderedRows, 0, ghostIndex), [_this._renderRow({
        preview: true,
        id: "preview"
      }, ghostIndex)], (0, _slice.default)(renderedRows).call(renderedRows, ghostIndex, rows.length)) : renderedRows;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getCategoryOptions", function () {
      if (_this.props.categoryList) {
        var _context3, _context4;

        return (0, _concat.default)(_context3 = [{
          id: "",
          label: _this.props.strings.defaultCategoryOption || "All"
        }]).call(_context3, (0, _map.default)(_context4 = _this.props.categoryList).call(_context4, function (item) {
          return {
            id: item,
            label: item
          };
        }));
      } else {
        return [];
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleCategoryToggle", function () {
      _this.props.onCategoryToggle(_this.props.index);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleCategoryClick", function (value) {
      _this.props.onCategoryClick(_this.props.index, value.id);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleDrag", function (targetIndex, beingDraggedIndex, targetColumn, beingDraggedColumn) {
      if (targetColumn === beingDraggedColumn && _this.props.disableSort) {
        return;
      }

      _this.props.onDrag(targetIndex, beingDraggedIndex, targetColumn, beingDraggedColumn);
    });
    return _this;
  }

  (0, _createClass2.default)(_class, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          category = _this$props2.category,
          categoryList = _this$props2.categoryList,
          dataId = _this$props2["data-id"],
          helpText = _this$props2.helpText,
          name = _this$props2.name,
          rows = _this$props2.rows,
          showCategoryList = _this$props2.showCategoryList,
          showCount = _this$props2.showCount,
          strings = _this$props2.strings;
      var className = (0, _classnames.default)(this.props.className, {
        "disable-sort": this.props.disableSort
      });

      var categoryOptions = this._getCategoryOptions();

      var selectedCategory = (0, _find.default)(_underscore.default).call(_underscore.default, categoryOptions, function (option) {
        return option.id === (category || "");
      });
      var helpHint = helpText ? /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
        className: "row-selector__column-helptext inline",
        "data-id": "".concat(dataId, "-helphint"),
        hintText: helpText
      }) : null;
      var filterLabel = categoryList ? strings.filteredByLabel || "filtered by" : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId,
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row-selector__column-header"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "row-selector__column-title"
      }, name, helpHint), showCount && rows && /*#__PURE__*/_react.default.createElement("span", {
        className: "row-selector__column-count"
      }, this.props.rowCount ? this.props.rowCount : rows.length), /*#__PURE__*/_react.default.createElement("span", {
        className: "row-selector__filters"
      }, filterLabel && /*#__PURE__*/_react.default.createElement("span", {
        className: "row-selector__filter-label"
      }, filterLabel, ":"), categoryList && /*#__PURE__*/_react.default.createElement(_LinkDropDownList.default, {
        className: "row-selector__category-selector",
        open: showCategoryList,
        label: selectedCategory.label,
        onClick: this._handleCategoryClick,
        onToggle: this._handleCategoryToggle,
        options: categoryOptions
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "items",
        onScroll: this._handleScroll,
        ref: "items"
      }, this._renderRows()));
    }
  }]);
  return _class;
}(_react.default.Component), (0, _defineProperty3.default)(_class, "propTypes", {
  "data-id": _propTypes.default.string,
  rows: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  name: _propTypes.default.string.isRequired,
  index: _propTypes.default.number.isRequired,
  filterCategory: _propTypes.default.string,
  categoryList: _propTypes.default.arrayOf(_propTypes.default.string),
  contentType: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]).isRequired,
  labelEmpty: _propTypes.default.string,
  rowCount: _propTypes.default.number,
  // optional
  ghostRowAt: _propTypes.default.number,
  className: _propTypes.default.string,
  disableSort: _propTypes.default.bool,
  dragToEdge: _propTypes.default.bool,
  strings: _propTypes.default.objectOf(_propTypes.default.string),
  // callbacks
  onDrag: _propTypes.default.func.isRequired,
  onDrop: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onScrolledToBottom: _propTypes.default.func,
  onScrolledToTop: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  showCategoryList: _propTypes.default.bool
}), (0, _defineProperty3.default)(_class, "defaultProps", {
  "data-id": "drag-drop-column",
  onScrolledToBottom: _underscore.default.noop,
  onScrolledToTop: _underscore.default.noop,
  labelEmpty: "No Items Added",
  onDragStart: _underscore.default.noop,
  onDragEnd: _underscore.default.noop,
  dragToEdge: false,
  showCategoryList: false,
  strings: {}
}), _temp);